import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints,
  palette,
}: Theme) => ({
  list: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '1.25rem 1rem',
    borderRadius: '1rem',
    backgroundColor: palette.secondary.light,
    fontSize: '0.875rem',
    textAlign: 'center',
    [breakpoints.up('md')]: {
      padding: '1.25rem 2rem',
      fontSize: '1rem',
    },
  },
  listNoRadius: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: '3.5rem',
    height: '3.5rem',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.5rem',
  },
}));
